import { EquipmentDto } from '@app/generated/model';

export class WorkOrderEquipment {
  description: string;
  number: string;
  functionalLocation: string;
  id: string;
  materialNo: string;
  materialName: string;
  serialNo: string;
  storageLocation: string;

  constructor(init: Partial<WorkOrderEquipment>) {
    Object.assign(this, init);
  }

  static fromDto(dto: EquipmentDto): WorkOrderEquipment {
    return new WorkOrderEquipment({
      description: dto.description,
      number: dto.number,
      functionalLocation: dto.functionalLocation,
      id: dto.id,
      materialNo: dto.materialNo,
      materialName: dto.materialName,
      serialNo: dto.serialNo,
      storageLocation: dto.storageLocation,
    });
  }
}
